module.exports = __webpack_public_path__ + "static/media/diamond.447b201e.svg";